module.exports = __webpack_public_path__ + "img/v1.3.00b974f5.png";